import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWrench, faFilter } from '@fortawesome/free-solid-svg-icons';

const DailyReportListTitleContainer = ({ setShowDailyReportSettings }) => {
    const [showSettingTooltip, setShowSettingTooltip] = useState(false);
    return (
        <div className="title-container">
            <div className="report-title">受け取った Daily Report の一覧</div>
            <div 
                className="setting-report setting-icon" 
                onMouseEnter={() => setShowSettingTooltip(true)} 
                onMouseLeave={() => setShowSettingTooltip(false)}
                onClick={() => setShowDailyReportSettings(true)} 
            >
                <FontAwesomeIcon icon={faWrench} />
                {showSettingTooltip ? <span className="setting-tooltip">デイリーレポートの受取りを管理</span> : null}
            </div>
        </div>
    )
}

export default DailyReportListTitleContainer